import consumer from "./consumer";

consumer.subscriptions.create("EasyUserChannel", {
  received(data) {
    consumer.helper.doSomething(data);
  },
  // Called once when the subscription is created.
  initialized() {
    this.update = this.update.bind(this);
  },

  // Called when the subscription is ready for use on the server.
  connected() {
    this.install();
    this.update();
    // @note object is part of RYS `notification_center`
    if (window.easyUserChannelConnected) {
      window.easyUserChannelConnected(this);
    }
  },

  // Called when the WebSocket connection is closed.
  disconnected() {
    this.uninstall();
  },

  // Called when the subscription is rejected by the server.
  rejected() {
    this.uninstall();
  },

  update() {
    if (this.documentIsActive()) {
      this.appear();
    }
  },

  appear() {
    // Calls `EasyUserChannel#appear(data)` on the server.
    // eslint-disable-next-line camelcase
    this.perform("appear", { appearing_on: this.appearingOn() });
  },

  away() {
    // Calls `EasyUserChannel#away` on the server.
    this.perform("away");
  },

  dnd() {
    // Calls `EasyUserChannel#dnd` on the server.
    this.perform("dnd");
  },

  invisible() {
    // Calls `EasyUserChannel#invisible` on the server.
    this.perform("invisible");
  },

  install() {
    window.addEventListener("focus", this.update);
    window.addEventListener("blur", this.update);
  },

  uninstall() {
    window.removeEventListener("focus", this.update);
    window.removeEventListener("blur", this.update);
  },

  documentIsActive() {
    return document.visibilityState === "visible" && document.hasFocus();
  },

  appearingOn() {
    const element = document.querySelector("[data-appearing-on]");
    return element ? element.getAttribute("data-appearing-on") : null;
  },
});
